import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import customerKeys from '@/api/queries/customers/keyFactory';
import { graphql } from '@/gql';

const GetCustomerQuery = graphql(`
  query Customer($customerId: ID!) {
    customer(id: $customerId) {
      id
      publicId
      name
      tags {
        id
        name
        colour
      }
      fileSharingSettings {
        attachToEmails
      }
      billingAddress {
        id
        line1
        line2
        city
        country
        administrativeArea
        postalCode
        fullLocalAddress
        coordinates {
          latitude
          longitude
        }
      }
      primaryContact {
        id
        name
        description
        email
        phone
      }
      contacts {
        id
        name
        description
        email
        phone
        isPrimary
        publicId
      }
      totals {
        projectValue {
          value
          currency {
            code
            exponent
          }
        }
        acceptedValue {
          value
          currency {
            code
            exponent
          }
        }
        sentInvoicedValue {
          value
          currency {
            code
            exponent
          }
        }
        completedPaymentValue {
          value
          currency {
            code
            exponent
          }
        }
      }
      addresses {
        id
        line1
        line2
        city
        country
        administrativeArea
        postalCode
        fullLocalAddress
        coordinates {
          latitude
          longitude
        }
        contacts {
          id
          publicId
          name
          description
          email
          phone
        }
      }
    }
  }
`);

const useGetCustomer = (customerId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!customerId,
    queryKey: customerKeys.customer(customerId!),
    queryFn: () =>
      gqlClient.request(GetCustomerQuery, {
        customerId: customerId!,
      }),
  });
  return {
    customer: data?.customer,
    data,
    ...rest,
  };
};

export default useGetCustomer;
